import t from "@/lang/lang";

/** Mirrors `positions.Unit`, backend/core/omni/domain/positions/unit.go. */
export const PositionUnit = {
  Euros: "euros",
  FlatRate: "flat-rate",
  Hours: "hours",
  Meter: "meter",
  Pieces: "pieces",
  Percent: "percent",
  PieceAndChange: "piece-and-change",
};

export type PositionUnit = (typeof PositionUnit)[keyof typeof PositionUnit];

export const PositionUnitList = Object.values(PositionUnit);

export const PositionUnitSelectItems = [
  { value: PositionUnit.Euros, label: t("Euro") },
  { value: PositionUnit.Meter, label: t("Meter") },
  { value: PositionUnit.FlatRate, label: t("Pauschal") },
  { value: PositionUnit.Percent, label: t("Prozent") },
  { value: PositionUnit.Pieces, label: t("Stück") },
  { value: PositionUnit.PieceAndChange, label: t("Stück & Wechsel") },
  { value: PositionUnit.Hours, label: t("Stunden") },
];
